import { makeStyles } from '@material-ui/core/styles';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  root: {
    '& ul.MuiList-root': {
      display: 'flex',

      '& .MuiListItem-root': {
        padding: '0 8px 0 0',
      },

      '& .MuiListItemText-primary': {
        fontSize: fonts.sizes.xsmall,
      },
    },
  },
});

export default useStyles;
